import { createFileRoute, lazyRouteComponent } from "@tanstack/react-router";

export const Route = createFileRoute("/admin/product-translations")({
  component: lazyRouteComponent(() => import("./-pages/admin.product-translations")),
  head: () => ({
    meta: [
      { title: "ترجمات المنتجات — إدارة Lecmo" },
      {
        name: "description",
        content: "ترجمة أسماء وأوصاف منتجات Shopify للعربيّة والإنجليزيّة آلياً أو يدويّاً.",
      },
    ],
  }),
});
